import { autoinject, transient, useView } from "aurelia-framework";
import { ValidationController, validationMessages } from "aurelia-validation";
import { CustomValidationRenderer } from "../../../../../../client-validation-system/custom-validation-renderer";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from "../../../../../../models/basics/basics.models";
import { IOrderMetaPlugin } from "../../../../../../models/rightstore/rightstore.models";

@autoinject()
@transient()
@useView('views/pages/modules/orders/plugins/vessel-esg-comparison-report/vessel-esg-comparison-report.html')
export class VesselEsgComparisionReport implements IOrderMetaPlugin {    
    public vesselEntityTypes: EntityTypeConfigurationModel[] = this.getVesselSearchConfig();
    public vessels: number[] = [null,null,null,null,null,null,null,null,null,null];

    public canSubmit: boolean = true;
    
    public get disableSubmit(): boolean
    {
        return false;
    }
    viewTitle: string = "Vessel ESG Comparison Report";
    constructor(private validationController: ValidationController,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper) {
        this.validationController.addRenderer(new CustomValidationRenderer());
        validationMessages['required'] = `\${$displayName} is required.`;
    }

    getVesselSearchConfig(): EntityTypeConfigurationModel[] {
        return this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["VesselSearch"])
    }

    onVesselSelected(index: number, vessel: any){
        if(vessel && vessel != null){
            this.vessels[index] = vessel.id
        }else{
            this.vessels[index] = null
        }
    }

    public async isValid(): Promise<boolean>
    {
        let valid = false;
        this.vessels.forEach(element => {
            if(element != null) {
                valid = true;
                return;
            }
        });
        return valid;
    }
    
    public getMetaModel()
    {
        const vesselIds = this.vessels.filter(x=> x != null);
        const metaModel = {
            vessels: vesselIds
        };

        return metaModel;
    }
}